'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fat';
var iconName = 'puzzle';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'e443';
var svgPathData = 'M304 24c0-4.4 3.6-8 8-8l144 0c22.1 0 40 17.9 40 40l0 120c0 4.4-3.6 8-8 8l-64 0c-4.4 0-8 3.6-8 8l0 24c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-24c0-4.4-3.6-8-8-8l-48 0c-4.4 0-8-3.6-8-8l0-24c0-4.4 3.6-8 8-8l16 0c22.1 0 40-17.9 40-40s-17.9-40-40-40l-16 0c-4.4 0-8-3.6-8-8l0-32zm8-24c-13.3 0-24 10.7-24 24l0 32c0 13.3 10.7 24 24 24l16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-16 0c-13.3 0-24 10.7-24 24l0 24c0 13.3 10.7 24 24 24l40 0 0 16c0 22.1 17.9 40 40 40s40-17.9 40-40l0-16 56 0c13.3 0 24-10.7 24-24l0-120c0-30.9-25.1-56-56-56L312 0zM56 64C25.1 64 0 89.1 0 120L0 456c0 30.9 25.1 56 56 56l336 0c30.9 0 56-25.1 56-56l0-152c0-13.3-10.7-24-24-24l-56 0c-13.3 0-24 10.7-24 24l0 16c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-16c0-13.3-10.7-24-24-24l-40 0 0-192c0-13.3-10.7-24-24-24L56 64zM216 88l0 192-40 0c-4.4 0-8-3.6-8-8l0-16c0-22.1-17.9-40-40-40s-40 17.9-40 40l0 16c0 4.4-3.6 8-8 8l-64 0 0-160c0-22.1 17.9-40 40-40l152 0c4.4 0 8 3.6 8 8zM80 296c13.3 0 24-10.7 24-24l0-16c0-13.3 10.7-24 24-24s24 10.7 24 24l0 16c0 13.3 10.7 24 24 24l40 0 0 40c0 4.4-3.6 8-8 8l-16 0c-22.1 0-40 17.9-40 40s17.9 40 40 40l16 0c4.4 0 8 3.6 8 8l0 64-160 0c-22.1 0-40-17.9-40-40l0-160 64 0zM232 432c0-13.3-10.7-24-24-24l-16 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l16 0c13.3 0 24-10.7 24-24l0-40 40 0c4.4 0 8 3.6 8 8l0 16c0 22.1 17.9 40 40 40s40-17.9 40-40l0-16c0-4.4 3.6-8 8-8l56 0c4.4 0 8 3.6 8 8l0 152c0 22.1-17.9 40-40 40l-160 0 0-64z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faPuzzle = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;